<template>
  <div v-show="tablePagination && lastPage > firstPage">
    <d-button v-if="showFirstLastButtons" @click="loadPage(firstPage)" link class="text-dark">
        <i class="material-icons">first_page</i>
    </d-button>
    <d-button @click="loadPage('prev')" link  class="text-dark">
        <i class="material-icons">chevron_left</i>
    </d-button>
    <template v-if="notEnoughPages">
      <template v-for="(n, i) in totalPage">
        <d-button @click="loadPage(i+firstPage)" :key="i" :link="!isCurrentPage(n)"  size="sm"
          theme="dark"
          :class="[!isCurrentPage(n) ? 'text-dark': '']"
          v-html="n">
        </d-button>
      </template>
    </template>
    <template v-else>
      <template v-for="(n, i) in windowSize">
        <d-button @click="loadPage(windowStart+i+firstPage-1)" :key="i"  :link="!isCurrentPage(windowStart+n-1)"  size="sm"
          v-html="windowStart+n-1" theme="dark" style="padding: 0 .75rem" :class="[!isCurrentPage(windowStart+n-1) ? 'text-dark': '']">
        </d-button>
      </template>
    </template>
    <d-button @click="loadPage('next')" link  class="text-dark">
      <i class="material-icons">chevron_right</i>
    </d-button>
    <d-button v-if="showFirstLastButtons" @click="loadPage(lastPage)" link class="text-dark">
      <i class="material-icons">last_page</i>
    </d-button>

  </div>
</template>

<script>
import PaginationMixin from './VuetablePaginationMixin.vue'

export default {
  mixins: [PaginationMixin],
  props: {
    showFirstLastButtons: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style>
  .vuetable-pagination {
    background: #f9fafb !important;
  }

  .active-pagination {
    border-bottom: 2px solid black;
    border-radius: 0;
  }
</style>
